import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Fac from 'Icons/Fac';

const useStyles = buildUseStyles('BigFacEnergy', (theme) => ({
  root: {
    position: 'relative',

    margin: `-${theme.spacing(1)}px`,
    padding: `${theme.spacing(1)}px`,
  },
  fac: {
    // Go to the far right of the content
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    // Be just outside of it
    top: -theme.spacing(1),
    right: -theme.spacing(1),
    // Be on top of the content
    zIndex: 1,
    // Look right
    color: theme.palette.facet.orange,
    '& > *': {
      fontSize: theme.spacing(6),
    },
  },
}));

export function BigFacEnergy({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.fac}>
        <Fac />
      </div>
      {children}
    </div>
  );
}

BigFacEnergy.propTypes = {
  children: PropTypes.node.isRequired,
};
